import BasicResource from '@/api/resource';

class ToolsResource extends BasicResource {
    constructor () {
        super('tools');
    }

    trackingTester (data) {
        return this.client.request ({
            method: 'POST',
            path: `/upyield/v1/${this.resourceName}/tracking-tester`,
            data,
        });
    }

    postbackTester (data) {
        return this.client.request ({
            method: 'POST',
            path: `/upyield/v1/${this.resourceName}/postback-tester`,
            data,
        });
    }
}

export default new ToolsResource;
